import { Link } from 'react-router-dom';

export default function CtaBanner() {
  return (
    <section style={{ background: 'var(--bg)', padding: '40px 20px 80px', borderTop: '1px solid var(--border)' }}>
      <div className="max-w-5xl mx-auto">
        <div
          className="relative overflow-hidden rounded-3xl px-8 lg:px-16 py-16 lg:py-24 text-center grad-border"
          style={{ background: 'rgba(232,97,26,0.06)' }}
        >
          <div className="absolute inset-0 pointer-events-none">
            <div style={{ position: 'absolute', top: '-100px', left: '50%', transform: 'translateX(-50%)', width: 600, height: 400, background: 'radial-gradient(ellipse, rgba(232,97,26,0.14) 0%, transparent 65%)', animation: 'mesh 8s ease-in-out infinite' }}></div>
            <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(var(--dot-color) 1px, transparent 1px)', backgroundSize: '32px 32px' }}></div>
          </div>

          <div className="relative">
            <div className="label inline-flex mb-6"><div className="label-dot"></div>Ücretsiz Danışmanlık</div>
            <h2
              className="reveal h-font"
              style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px, 5vw, 64px)', color: 'var(--text1)', lineHeight: 1.05, marginBottom: 20 }}
            >
              Lojistiğinizi bir üst<br />seviyeye taşıyalım.
            </h2>
            <p
              className="reveal d2"
              style={{ fontSize: 16, color: 'var(--text2)', marginBottom: 40, maxWidth: 480, margin: '0 auto 40px' }}
            >
              Bugün iletişime geçin, 24 saat içinde size özel lojistik çözüm teklifimizi hazırlayalım.
            </p>
            <div className="reveal d3 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link to="/iletisim" className="btn-primary">
                Ücretsiz Teklif Al <i className="ri-arrow-right-line bounce-x"></i>
              </Link>
              <a
                href="tel:+908502420822"
                rel="nofollow"
                className="flex items-center gap-2 whitespace-nowrap cursor-pointer transition-colors duration-300"
                style={{ color: 'var(--text2)', fontWeight: 600, fontSize: 15 }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--text1)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--text2)')}
              >
                <i className="ri-phone-line text-[#E8611A]"></i> 0850 242 0 822
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
